import t from "./ghl-ui.es1461.js";
import o from "./ghl-ui.es1462.js";
import a from "./ghl-ui.es1463.js";
import r from "./ghl-ui.es1464.js";
import m from "./ghl-ui.es1465.js";
var e = {
  code: "pt",
  formatDistance: t,
  formatLong: o,
  formatRelative: a,
  localize: r,
  match: m,
  options: {
    weekStartsOn: 1,
    firstWeekContainsDate: 4
  }
};
const p = e;
export {
  p as default
};
